import { render, staticRenderFns } from "./TakeCamera.vue?vue&type=template&id=2513ef40&"
import script from "./TakeCamera.vue?vue&type=script&lang=js&"
export * from "./TakeCamera.vue?vue&type=script&lang=js&"
import style0 from "./TakeCamera.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports